import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { applyTheme, defaultTheme } from '@fetmode/theme';
import '@fetmode/app-core/styles/global.css';
import '@fetmode/app-core/styles/ConfirmModal.css';
import '@fetmode/app-core/styles/ShowChatPanel.css';
import '@fetmode/app-core/styles/ShowChatShell.css';
import '@fetmode/app-core/styles/StreamHealthBanner.css';
import '@fetmode/app-core/styles/LiveVideoControls.css';
import '@fetmode/app-core/auth/RegisterPage.css';
import '@fetmode/app-core/auth/RegisterLegalConsent.css';
import '@fetmode/app-core/auth/register-name-fields.css';
import '@fetmode/app-core/auth/SocialAuthButtons.css';
import { App } from './App.js';

applyTheme(defaultTheme);

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
